import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core'

@Component({
  selector: 'app-data-reconciliation',
  templateUrl: './data-reconciliation.component.html',
  styleUrls: ['./data-reconciliation.component.scss'],
})
export class DataReconciliationComponent implements OnChanges {
  @Input() visible = false
  @Input() userName = ''
  @Input() userEmail = ''

  @Output() close = new EventEmitter<void>()
  @Output() confirmRegistration = new EventEmitter<void>()

  emailErrorMessage = ''
  isFormValid = false

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userEmail']) {
      this.validateEmail()
    }
    if (changes['userName']) {
      this.validateForm()
    }
  }

  onClose(): void {
    this.close.emit()
  }

  onEmailChange(value: string): void {
    this.userEmail = value
    this.validateEmail()
  }

  validateEmail(): void {
    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!this.userEmail) {
      this.emailErrorMessage = 'Kérlek add meg az email címed'
    } else if (!EMAIL_REGEX.test(this.userEmail)) {
      this.emailErrorMessage = 'Nem érvényes email formátum'
    } else {
      this.emailErrorMessage = ''
    }
    this.validateForm()
  }

  validateForm(): void {
    this.isFormValid = !!this.userEmail && !this.emailErrorMessage && !!this.userName
  }

  onConfirmRegistration(): void {
    if (!this.isFormValid) {
      return
    }
    this.confirmRegistration.emit()
    this.onClose()
  }
}
